import {
    GET_JOBPROFILE_REQUEST,
    GET_JOBPROFILE_FAILURE,
    GET_JOBPROFILE_SUCCESS,
    UPDATE_JOBPROFILE_REQUEST,
    UPDATE_JOBPROFILE_SUCCESS,
    UPDATE_JOBPROFILE_FAILURE
} from "../constants/jobProfileActionTypes"

const initialState = {
    jobProfile: {},
    loading: {
        getJobProfile: false,
        updateJobProfile: false
    },
    error: null
}

const jobProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_JOBPROFILE_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getJobProfile: true },
                error: null
            };
        case GET_JOBPROFILE_SUCCESS:
            return {
                ...state,
                jobProfile: action.payload,
                loading: { ...state.loading, getJobProfile: false }
            };
        case GET_JOBPROFILE_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, getJobProfile: false },
                error: action.payload
            };
        case UPDATE_JOBPROFILE_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, updateJobProfile: true },
                error: null
            };
        case UPDATE_JOBPROFILE_SUCCESS:
            return {
                ...state,
                jobProfile: action.payload,
                loading: { ...state.loading, updateJobProfile: false }
            };
        case UPDATE_JOBPROFILE_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, updateJobProfile: false },
                error: action.payload
            };
        default:
            return state;
    }
}

export default jobProfileReducer;